// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2jKET","footer":"ModalUpdate_footer__3NMF2"};